import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.path('/stonecode_file_file_statuses/{?id}')
@doc.timestampable
abstract class AbstractStonecodeFileFileStatusModel extends WebsiteServiceModel {
	declare private _tsSorts: {
		id: string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Website_StonecodeFileFileStatusReference;
}

interface AbstractStonecodeFileFileStatusModel extends Timestampable {}

export default AbstractStonecodeFileFileStatusModel;
